module.exports = __webpack_public_path__ + "img/sand-dune-decal-15.6b4bc431.png";